"use strict";

;
(function (AboutCircleText, $) {
  var updateRadius = function updateRadius() {
    var containers = document.getElementsByClassName('top-text');
    Object.keys(containers).map(function (key) {
      var text = new CircleType(containers[key]);
      text.radius(text.element.offsetWidth / 2);
    });
  };
  var eventHandlers = function eventHandlers() {
    $(window).on('resize', function () {
      updateRadius();
    });
  };
  AboutCircleText.init = function () {
    eventHandlers();
    updateRadius();
  };
})(window.AboutCircleText = window.AboutCircleText || {}, jQuery, undefined);